module.exports = __webpack_public_path__ + "img/bsignup-continue-3@3x.2664a3e4.png";